//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import _ from 'lodash';

class MembershipListHelper {
    static getOptions(membershipOptions) {
        return membershipOptions.map((membership) => {
            const { title, iri } = membership;

            return {
                value: iri,
                label: title,
            };
        });
    }

    static getCurrentMembershipOption(membershipOptions, option) {
        if (!membershipOptions.length) {
            return {
                value: null,
                label: 'none',
            };
        }

        return option ?
            _.find(membershipOptions, {
                iri: option,
            }) :
            _.first(membershipOptions);
    }
}

export default MembershipListHelper;
